import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { twMerge } from 'tailwind-merge';

interface IDropImage {
  onFileSelected(file: File): void;
  className?: string;
  style?: React.CSSProperties;
  accept?: string;
}

// Helper to parse accept string into correct object format for react-dropzone
function parseAccept(accept?: string) {
  if (!accept) return undefined;
  const acceptArr = accept
    .split(',')
    .map((a) => a.trim())
    .filter(Boolean);
  const acceptObj: Record<string, string[]> = {};
  acceptArr.forEach((item) => {
    if (item) acceptObj[item] = [];
  });
  return Object.keys(acceptObj).length > 0 ? acceptObj : undefined;
}

export function DropImage({
  onFileSelected,
  className,
  children,
  style,
  accept,
}: React.PropsWithChildren<IDropImage>) {
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      onFileSelected(acceptedFiles[0]);
    },
    [onFileSelected],
  );
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: 1,
    accept: parseAccept(accept),
  });
  return (
    <div
      style={style}
      {...getRootProps()}
      className={twMerge(
        'h-[512px] w-[512px] rounded-xl border-4 border-dashed border-gray-400 bg-white',
        className,
      )}>
      <input {...getInputProps()} />
      {children}
    </div>
  );
}
